import { ReactiveVar } from '@apollo/client';

import {
  IJobTitlesInstitution,
  IJobTitlesInstitutionCache,
  jobTitlesInstitutionReactiveVar,
} from '../../cache/learner/jobTitlesInstitutionReactiveVar';
import { IFeatures } from '../../contexts/reducer/featureFlagsReducer';

export interface IJobTitlesInstitutionReactiveVarHook {
  operations: {
    setJobTitlesInstitutionData: (data: IJobTitlesInstitution[]) => void;
    isDemo: (jobTitleId: string, features: IFeatures) => boolean;
    jobTitlesInstitutionDataCache: IJobTitlesInstitutionCache;
  };
}

const useJobTitlesInstitutionReactiveVarHook = (
  jobTitlesInstitutionProp: ReactiveVar<IJobTitlesInstitutionCache>,
): IJobTitlesInstitutionReactiveVarHook => {
  const jobTitlesInstitutionDataCache = jobTitlesInstitutionProp();
  const setJobTitlesInstitutionData = (data: IJobTitlesInstitution[]): void => {
    jobTitlesInstitutionReactiveVar({
      data,
    });
  };
  const isDemo = (jobTitleId: string, features: IFeatures): boolean =>
    !!features.occupationsLimitedEnabled &&
    jobTitlesInstitutionDataCache.data.length > 0 &&
    !jobTitlesInstitutionDataCache.data.some((jobTitleInstitution) => jobTitleInstitution.jobTitleId === jobTitleId);

  return {
    operations: {
      setJobTitlesInstitutionData,
      jobTitlesInstitutionDataCache,
      isDemo,
    },
  };
};

export default useJobTitlesInstitutionReactiveVarHook;
